import React from 'react';
import PropTypes from 'prop-types';
import { PulseLoader } from 'halogenium';

export default class Card extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    this.props.request().then((result) => {
      this.setState({ loading: false });
      this.props.onLoad(result);
    }).catch(() => {
      this.setState({ loading: false });
      // TODO: error reporting here
      this.props.onLoad();
    });
  }

  renderContent() {
    if (this.state.loading) {
      return (
        <PulseLoader
          className="card-loader"
          color="#4F94E3"
          size="20px"
        />
      );
    }

    return this.props.children;
  }

  render() {
    return (
      <div className="card">
        <h4>{this.props.title}</h4>
        <div className={this.props.content_class}>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  content_class: PropTypes.string,
  request: PropTypes.func,
  onLoad: PropTypes.func
};

Card.defaultProps = {
  content_class: '',
  request: () => Promise.resolve(),
  onLoad: () => Promise.resolve()
};
